import { TapResponseFrame, TapRequestFrame } from '@iotize/tap/client/api';
import {
  HostProtocol,
  TargetProtocol,
  VariableFormat,
  AppPathType,
  SpecialFeature,
  TapVersion,
} from '@iotize/tap';

/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export enum GPIOMode {
  INPUT_FLOATING = 0,
  OUTPUT_OPEN_DRAIN = 1,
  OUTPUT_PUSH_PULL = 3,
  INPUT_PULL_UP = 4,
  OUTPUT_OPEN_DRAIN_PULL_UP = 5,
  INPUT_PULL_DOWN = 8,
}
